"use strict"

const angular = require("angular");

angular
    .module("Agnes")
    .factory("$notification", [
        "$rootScope", "$timeout",
        function ($rootScope, $timeout) {
            $rootScope.notifications = [];

            var $notification = {};
            $notification.addInfo = function (message) {
                var notification = {
                    type: "info",
                    message: message
                };
                $rootScope.notifications.push(notification);
                $timeout(function () {
                    $notification.close(notification);
                }, 5000);
            };
            $notification.addSuccess = function (message) {
                var notification = {
                    type: "success",
                    message: message
                };
                $rootScope.notifications.push(notification);
                $timeout(function () {
                    $notification.close(notification);
                }, 5000);
            };
            $notification.addError = function (message, response) {
                var notification = {
                    type: "danger",
                    message: message,
                    response: response
                };
                $rootScope.notifications.push(notification);
            };
            $notification.close = function (notification) {
                var index = $rootScope.notifications.indexOf(notification);
                $rootScope.notifications.splice(index, 1);
            };

            return $notification;
        }
    ]);